import { TijdlijnTaakType } from "../enums";

// Suggested time options in minutes
export const TIME_SUGGESTIONS = [5, 10, 15, 30, 45, 60, 90, 120];

// No default time for a task type
export const getDefaultTaskTime = (
  _taskType: TijdlijnTaakType,
): number | undefined => {
  return undefined;
};

// Format minutes for display
export const formatMinutes = (minutes: number | null | undefined): string => {
  if (!minutes) return "-";

  if (minutes < 60) {
    return `${minutes}min`;
  } else {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    if (remainingMinutes === 0) {
      return `${hours}u`;
    } else {
      return `${hours}u ${remainingMinutes}min`;
    }
  }
};

// Clean task type labels (no emojis). C10: de enige taaknamen in de frontend;
// moeten gelijk blijven aan backend/src/domain/taaktype-labels.ts (test daar).
export const getCleanTaskTypeLabel = (taskType: TijdlijnTaakType): string => {
  const labels: Record<TijdlijnTaakType, string> = {
    [TijdlijnTaakType.AANTEKENINGEN_EN_RADIOLOGIE_AANVRAAG]:
      "Aantekeningen & Radiologie aanvraag",
    [TijdlijnTaakType.UITNODIGEN_BETROKKENE]: "Uitnodigen Betrokkene",
    [TijdlijnTaakType.VOORBEREIDEN_PM]: "Voorbereiden PM",
    [TijdlijnTaakType.VOORBEREIDEN_ASSISTENT]: "Voorbereiden Assistent",
    [TijdlijnTaakType.UITWERKEN_RAPPORT]: "Uitwerken Rapport",
    [TijdlijnTaakType.VERSTUREN_CONCEPTRAPPORT_BETROKKENE]:
      "Concept naar Betrokkene",
    [TijdlijnTaakType.VERWERKEN_REACTIE_BETROKKENE]: "Reactie Betrokkene",
    [TijdlijnTaakType.VERSTUREN_CONCEPTRAPPORT_OG]: "Concept naar OG",
    [TijdlijnTaakType.BEVESTIGEN_OG]: "Bevestigen OG",
    [TijdlijnTaakType.VERSTUREN_FACTUUR]: "Versturen Factuur",
    [TijdlijnTaakType.VERWERKEN_REACTIE_OG]: "Reactie OG",
    [TijdlijnTaakType.AANVULLENDE_VRAGEN_UITWERKEN]:
      "Aanvullende vragen uitwerken",
    [TijdlijnTaakType.VERSTUREN_DEFINITIEF_RAPPORT]: "Definitief Rapport",
    [TijdlijnTaakType.VERSTUREN_AANVULLENDE_FACTUUR]: "Aanvullende Factuur",
    [TijdlijnTaakType.ON_HOLD]: "On Hold",
    [TijdlijnTaakType.OVERIG]: "Overig",
  };
  return labels[taskType] || taskType;
};
